(function () {
  'use strict';

  var strings = window.themeStrings || {};

  function interpolate(template, values) {
    return Object.keys(values || {}).reduce(function (text, key) {
      return text.split('{' + key + '}').join(String(values[key]));
    }, template || '');
  }

  var STORAGE_KEY = 'hg-cart-saved';
  var memoryFallback = [];

  function handleFromUrl(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (_error) {
      return match[1];
    }
  }

  function normalize(item) {
    if (!item || !item.variantId) return null;

    var variantId = String(item.variantId);
    if (!/^\d+$/.test(variantId)) return null;

    var quantity = parseInt(item.quantity, 10);
    if (!quantity || quantity < 1) quantity = 1;
    quantity = Math.min(quantity, 999);

    var handle = String(item.handle || handleFromUrl(item.url) || '');
    if (!/^[a-z0-9-]+$/i.test(handle)) handle = '';

    return {
      variantId: variantId,
      quantity: quantity,
      handle: handle,
      title: String(item.title || ''),
      variantTitle: String(item.variantTitle || ''),
      vendor: String(item.vendor || ''),
      url: String(item.url || ''),
      price: Number(item.price) || 0,
      image: String(item.image || '')
    };
  }

  function normalizeList(items) {
    var result = [];
    var positions = {};

    (Array.isArray(items) ? items : []).forEach(function (rawItem) {
      var item = normalize(rawItem);
      if (!item) return;

      if (Object.prototype.hasOwnProperty.call(positions, item.variantId)) {
        var position = positions[item.variantId];
        result[position] = Object.assign({}, result[position], item, {
          quantity: Math.max(result[position].quantity, item.quantity)
        });
        return;
      }

      positions[item.variantId] = result.length;
      result.push(item);
    });

    return result;
  }

  function read() {
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      memoryFallback = normalizeList(stored);
    } catch (_error) {
      /* Private browsing and locked-down contexts can deny localStorage.
         The list still works for the current page through memoryFallback. */
    }
    return memoryFallback.slice();
  }

  function announce(message) {
    var status = document.getElementById('a11y-status');
    if (!status) return;
    status.textContent = '';
    window.setTimeout(function () {
      status.textContent = message;
    }, 20);
  }

  function dispatch(items, detail) {
    document.dispatchEvent(new CustomEvent('saved-products:updated', {
      detail: Object.assign({ items: items.slice() }, detail || {})
    }));
  }

  function write(items, detail) {
    var normalized = normalizeList(items);
    memoryFallback = normalized;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
    } catch (_error) {
      /* See read(): memory fallback is deliberate. */
    }
    syncButtons(document, normalized);
    dispatch(normalized, detail);
    return normalized.slice();
  }

  function add(rawItem, detail) {
    var item = normalize(rawItem);
    if (!item) return read();

    var items = read();
    var found = false;
    items = items.map(function (existing) {
      if (existing.variantId !== item.variantId) return existing;
      found = true;
      return Object.assign({}, existing, item, {
        quantity: Math.max(existing.quantity, item.quantity)
      });
    });
    if (!found) items.unshift(item);
    return write(items, Object.assign({ action: 'add', item: item }, detail || {}));
  }

  function addMany(rawItems, detail) {
    var items = read();
    normalizeList(rawItems).slice().reverse().forEach(function (item) {
      var index = items.findIndex(function (existing) {
        return existing.variantId === item.variantId;
      });
      if (index === -1) {
        items.unshift(item);
      } else {
        items[index] = Object.assign({}, items[index], item, {
          quantity: Math.max(items[index].quantity, item.quantity)
        });
      }
    });
    return write(items, Object.assign({ action: 'add-many' }, detail || {}));
  }

  function remove(variantId, detail) {
    var id = String(variantId || '');
    var removed = null;
    var items = read().filter(function (item) {
      if (item.variantId !== id) return true;
      removed = item;
      return false;
    });
    return write(items, Object.assign({ action: 'remove', item: removed }, detail || {}));
  }

  function setQuantity(variantId, rawQuantity, detail) {
    var id = String(variantId || '');
    var quantity = parseInt(rawQuantity, 10);
    if (!quantity || quantity < 1) quantity = 1;
    quantity = Math.min(quantity, 999);

    var changed = null;
    var items = read().map(function (item) {
      if (item.variantId !== id) return item;
      changed = Object.assign({}, item, { quantity: quantity });
      return changed;
    });

    if (!changed) return items;
    return write(items, Object.assign({ action: 'quantity', item: changed }, detail || {}));
  }

  function contains(variantId, items) {
    var id = String(variantId || '');
    return (items || read()).some(function (item) {
      return item.variantId === id;
    });
  }

  function buttonItem(button) {
    return normalize({
      variantId: button.getAttribute('data-variant-id'),
      quantity: 1,
      handle: button.getAttribute('data-product-handle'),
      title: button.getAttribute('data-product-title'),
      variantTitle: button.getAttribute('data-variant-title'),
      vendor: button.getAttribute('data-product-vendor'),
      url: button.getAttribute('data-product-url'),
      price: button.getAttribute('data-product-price'),
      image: button.getAttribute('data-product-image')
    });
  }

  function syncButton(button, items) {
    var saved = contains(button.getAttribute('data-variant-id'), items);
    var title = button.getAttribute('data-product-title') || '';
    var visibleLabel = button.querySelector('[data-save-product-label]');
    button.classList.toggle('is-saved', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.setAttribute('aria-label', (saved ? strings.removeSaved || 'Ta bort från prisunderlag' : strings.saveProduct || 'Spara till prisunderlag') + (title ? ': ' + title : ''));
    if (visibleLabel) {
      visibleLabel.textContent = saved
        ? visibleLabel.getAttribute('data-saved-label')
        : visibleLabel.getAttribute('data-unsaved-label');
    }
  }

  function syncButtons(root, suppliedItems) {
    var scope = root || document;
    var items = suppliedItems || read();
    var buttons = [];
    if (scope.matches && scope.matches('[data-save-product]')) buttons.push(scope);
    if (scope.querySelectorAll) {
      buttons = buttons.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-save-product]')));
    }
    buttons.forEach(function (button) {
      syncButton(button, items);
    });
  }

  function publish(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('hjartgruppen:' + name, payload);
      }
    } catch (_error) {
      /* Analytics must never block the shopping action. */
    }
  }

  function trackSaved(item) {
    var payload = {
      currency: 'SEK',
      value: item.price / 100,
      items: [{
        item_id: item.variantId,
        item_name: item.title,
        item_variant: item.variantTitle,
        price: item.price / 100,
        quantity: 1
      }]
    };
    publish('saved_product_added', payload);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: 'add_to_wishlist', ecommerce: payload });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-save-product]');
    if (!button) return;

    var item = buttonItem(button);
    if (!item) return;
    event.preventDefault();

    if (contains(item.variantId)) {
      remove(item.variantId, { source: 'heart' });
      announce(interpolate(strings.savedRemoved || '{title} har tagits bort från prisunderlaget.', { title: item.title }));
    } else {
      add(item, { source: 'heart' });
      trackSaved(item);
      announce(interpolate(strings.savedAdded || '{title} har sparats till prisunderlaget.', { title: item.title }));
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) return;
    var items = read();
    syncButtons(document, items);
    dispatch(items, { action: 'storage' });
  });

  window.themeSavedProducts = {
    storageKey: STORAGE_KEY,
    read: read,
    write: write,
    add: add,
    addMany: addMany,
    remove: remove,
    setQuantity: setQuantity,
    contains: contains,
    syncButtons: syncButtons,
    handleFromUrl: handleFromUrl,
    publish: publish,
    announce: announce
  };

  syncButtons(document);
})();
